import { useState, useCallback } from "react";
import axios from "axios";
import moment from "moment";
import cSharpApi from "../../../../../../services/api/CSharpApi";
import { CurrentData, CurrentDataState, CurrentDatum } from "../../../SimpleAppTemplate";

interface CurrentVolumeDatum extends CurrentDatum {
  maxValue: number;
}

interface CurrentVolumeData extends CurrentData {
  currentData: CurrentVolumeDatum;
  hasTankArea: boolean;
  hasTankDepth: boolean;
}

interface CurrentVolumeDataState extends CurrentDataState {
  data: CurrentVolumeData;
}

type FetchParams = {
  name: string;
  fieldKey: string;
  tankArea: number;
  tankDepth: number;
  hoursToAdd: number;

  displayName?: string;
  fieldName?: string;
  portNumber: number;
  orgId?: string;
};

const INITIAL_STATE = {
  data: {
    currentData: {
      time: moment(),
      value: 0,
      maxValue: 0,
      valueDisplayUnit: "",
    },
    hasData: false,
    hasTankArea: false,
    hasTankDepth: false,
    errorMessage: "",
  },
  isLoading: false,
  hasError: false,
  errorMessage: "",
  message: "",
};

const useCurrentWaterVol = (deviceId: string) => {
  // @ts-expect-error
  const [fetchedData, setFetchedData] = useState<CurrentVolumeDataState>(INITIAL_STATE);

  const cancelTokenSource = axios.CancelToken.source();

  const fetchData = useCallback(
    async (params: FetchParams) => {
      // @ts-expect-error
      setFetchedData({
        ...INITIAL_STATE,
        isLoading: true,
      });

      try {
        const response = await cSharpApi.post(
          `charts/get-current-water-volume/${deviceId}`,
          JSON.stringify(params),
          {
            cancelToken: cancelTokenSource.token,
          },
        );

        const data = await response.data.data;

        if (data) {
          setFetchedData({
            data,
            isLoading: false,
            hasError: false,
            errorMessage: "",
            message: response.data.message,
          });
        }
      } catch (error) {
        let errorMessage = "fetching data aborted";

        if (axios.isCancel(error)) {
          console.log("fetching data aborted");
        } else {
          errorMessage = error instanceof Error ? error.message : "Unknown error";
          console.log("An error occurred", error);
        }

        // @ts-expect-error
        setFetchedData({
          ...INITIAL_STATE,
          errorMessage,
        });
      }
      return () => cancelTokenSource.cancel();
    },
    [deviceId],
  );

  const { data, isLoading, hasError, errorMessage, message } = fetchedData;

  return { fetchData, data, isLoading, hasError, errorMessage, message };
};

export default useCurrentWaterVol;
